import { render, staticRenderFns } from "./ReceptionBoxForm.vue?vue&type=template&id=1ee34e5a"
import script from "./ReceptionBoxForm.vue?vue&type=script&lang=js"
export * from "./ReceptionBoxForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports